import axios, { type AxiosRequestConfig } from "axios";
import { useAuthenticatedUserStore } from "@/modules/authentication/authentication-store";

export const httpClient = axios.create({
  timeout: 10000,
  baseURL: "/api",
});

httpClient.interceptors.request.use(async (config) => {
  const userStore = useAuthenticatedUserStore();

  config.headers["X-Requested-With"] = "XMLHttpRequest";

  const user = await userStore.requireUser();
  if (!user.isAuthenticated) {
    return Promise.reject(
      new Error(
        "Du är inte längre inloggad. Spara ditt arbete och ladda om sidan",
      ),
    );
  }

  return config;
});

httpClient.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  async function (error: unknown) {
    const userStore = useAuthenticatedUserStore();

    // If we're getting a 401 from the api we'll need to revaluate the user session
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      userStore.revaluateAuthenticatedUser();
    }

    // Any status codes that falls outside the range of 2xx cause this function to trigger
    return Promise.reject(error);
  },
);

export default (config: AxiosRequestConfig) => {
  config.baseURL = "/api";
  return httpClient(config);
};
